import { memo } from "react";

import { defaultToTrue } from "@Components/Modules/Helpers";

export default memo(
    (props: React.SVGProps<SVGSVGElement>) => (
        <svg viewBox="0 0 24.71 29.67" {...props} fill={props.color || "#fff"}>
            <path d="M10.33,10.52l1.76,1.57L17.46,6,12.06-.07,10.29,1.5l2.94,3.33H7.06A7.07,7.07,0,0,0,0,11.89v6.48H2.35V11.89a4.72,4.72,0,0,1,4.71-4.7h6.21Z" />
            <path d="M22.36,11.3v6.48a4.71,4.71,0,0,1-4.71,4.7H11.44l3-3.33-1.77-1.57L7.25,23.66l5.4,6.08,1.77-1.57-2.95-3.33h6.18a7.07,7.07,0,0,0,7.06-7.06V11.3Z" />
        </svg>
    ),
    defaultToTrue,
);
